import axios from 'axios';

/**
 * Extract a human-readable error message from an unknown error.
 *
 * For Axios errors this prefers the backend's response body in the following
 * order: `error`, `message`, `detail`, `title` — matching the shapes used by
 * the v2 API (`{ error: "..." }`) and ProblemDetails.
 */
export const getErrorMessage = (error: unknown, fallback: string): string => {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data;
    if (data && typeof data === 'object') {
      const body = data as Record<string, unknown>;
      for (const key of ['error', 'message', 'detail', 'title'] as const) {
        const value = body[key];
        if (typeof value === 'string' && value.trim().length > 0) {
          return value;
        }
      }
    }
    if (typeof data === 'string' && data.trim().length > 0) {
      return data;
    }
    return error.message || fallback;
  }

  if (error instanceof Error) {
    return error.message || fallback;
  }

  return fallback;
};
